<template>
  <div class="main-wrapper" v-if="themes">
    <el-tabs v-model="activeName" @tab-click="btnTabsClick">
      <el-tab-pane label="我的模板" name="my">
      </el-tab-pane>
      <el-tab-pane label="官方模板" name="published">
      </el-tab-pane>
    </el-tabs>

    <el-table :data="themes" width="100%">
      <el-table-column label="作者" width="150">
        <template #default="scope">
          {{ scope.row.userName }}
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template #default="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="150">
        <template #default="scope">
          {{ scope.row.updatedDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="400">
        <template #default="scope">
          <div v-if="isAuthenticated(scope.row)" class="actions">
            <el-dropdown @command="btnDeployClick">
              <el-link type="primary" :underline="false" href="javascript:;" class="el-dropdown-link">
                部 署
                <i class="el-icon-arrow-down"></i>
              </el-link>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :command="{ name: 'Buy', theme: scope.row }">一键部署</el-dropdown-item>
                  <el-dropdown-item :disabled="!isHostExists" :command="{ name: 'Deploy', theme: scope.row }">
                    部署到现有网站云
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <el-link type="primary" :underline="false" href="javascript:;" @click.prevent="btnDownloadClick(scope.row)">下 载</el-link>
            <el-link
              type="danger"
              :underline="false"
              href="javascript:;"
              v-if="scope.row.userName === userName"
              @click.prevent="btnDeleteClick(scope.row)"
            >
              删 除
            </el-link>
          </div>
          <div v-else class="actions">
            <el-link type="primary" :underline="false" href="javascript:;" @click.prevent="btnDeployClick({ name: 'Buy', theme: scope.row })">一键部署</el-link>
            <el-link type="primary" :underline="false" href="javascript:;" @click.prevent="btnBuyClick(scope.row)">购 买</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-divider></el-divider>

    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click.prevent="btnUploadClick">上传模板</el-button>
      </el-form-item>
    </el-form>

    <el-drawer title="购买模板" direction="rtl" size="60%" v-model="isBuy">
      <buy :userName="theme.userName" :name="theme.name" @close="btnBuyCloseClick" />
    </el-drawer>

    <el-drawer title="部署到网站云" direction="rtl" size="60%" v-model="isDeploy">
      <deploy :userName="theme.userName" :name="theme.name" @close="isDeploy = false" />
    </el-drawer>

    <el-drawer title="上传模板" direction="rtl" size="60%" v-model="isUpload">
      <el-form style="margin: 0 30px" label-position="left" ref="uploadForm">
        <el-form-item>
          <el-upload
            :drag="true"
            :limit="1"
            :action="uploadUrl"
            :auto-upload="true"
            :headers="{ Authorization: 'Bearer ' + uploadToken }"
            :show-file-list="false"
            :before-upload="uploadBefore"
            :on-progress="uploadProgress"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :multiple="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将CMS系统中保存的站点模板压缩包（ZIP文件）拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button @click="isUpload = false">取 消</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import api from '@/api/my/templates';
import { auth } from '@/store';
import Deploy from './components/templates/Deploy.vue';
import Buy from './components/templates/Buy.vue';

interface IState {
  activeName: string;
  themes: ITheme[];
  orderResourceIds: string[];
  userName: string;
  isHostExists: boolean;
  theme: ITheme;
  isBuy: boolean;
  isDeploy: boolean;
  uploadToken: string;
  uploadUrl: string;
  isUpload: boolean;
}

export default defineComponent({
  components: {
    Deploy,
    Buy,
  },
  data() {
    return {
      activeName: 'my',
      themes: [],
      orderResourceIds: [],
      userName: '',
      isHostExists: false,
      theme: {} as ITheme,
      isBuy: false,
      isDeploy: false,
      uploadToken: auth.token,
      uploadUrl: api.getUploadUrl(),
      isUpload: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get({ type: this.activeName }, (res) => {
        this.themes = res.themes;
        this.orderResourceIds = res.orderResourceIds;
        this.userName = res.userName;
        this.isHostExists = res.isHostExists;
      });
    },

    apiDelete(theme: ITheme) {
      api.delete(
        {
          name: theme.name,
        },
        (res) => {
          if (!res) return;
          utils.success('模板删除成功！');
          this.apiGet();
        },
      );
    },

    getUrl(relatedUrl: string) {
      return `https://sscms.com/themes/${relatedUrl}`;
    },

    getDownloadUrl(theme: ITheme) {
      return `https://dl.sscms.com/themes/${theme.userName}/T_${theme.name}.zip`;
    },

    isAuthenticated(theme: ITheme) {
      if (theme.price > 0 && theme.userName !== this.userName) {
        return this.orderResourceIds.indexOf(theme.guid) !== -1;
      }
      return true;
    },

    btnTabsClick() {
      this.apiGet();
    },

    btnBuyClick(theme: ITheme) {
      this.theme = theme;
      this.isBuy = true;
    },

    btnDeployClick(args: { name: string; theme: ITheme }) {
      if (args.name === 'Buy') {
        utils.pageOpen(`/my/create/${args.theme.userName}-${args.theme.name}`);
      } else if (args.name === 'Deploy') {
        this.isDeploy = true;
        this.theme = args.theme;
      }
    },

    btnDownloadClick(theme: ITheme) {
      api.getTheme(
        {
          userName: theme.userName,
          name: theme.name,
        },
        (res) => {
          if (!res) return;
          window.open(res.themeDownloadUrl);
        },
      );
    },

    btnDeleteClick(theme: ITheme) {
      utils.alertDelete(
        {
          title: '删除模板',
          text: `此操作将删除模板 ${theme.name}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(theme);
        },
      );
    },

    btnUploadClick() {
      this.isUpload = true;
    },

    btnBuyCloseClick() {
      this.isBuy = false;
      this.apiGet();
    },

    uploadBefore(file: { name: string }) {
      const isZip = file.name.indexOf('.zip', file.name.length - '.zip'.length) !== -1;
      if (!isZip) {
        utils.error('模板文件只能是 Zip 格式!');
      }
      return isZip;
    },

    uploadProgress() {
      utils.loading(true);
    },

    uploadSuccess() {
      utils.success('模板上传成功！');
      this.isUpload = false;
      this.apiGet();
    },

    uploadError(err: { message: string }) {
      utils.loading(false);
      const error = JSON.parse(err.message);
      utils.error(error.message);
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
